import { delay, call, put, select, takeEvery } from 'redux-saga/effects';
import * as signaturesActions from '../../actions/signatures/signaturesActions';
import { getAllSignaturesRequest } from '../../../api/signatures/getAllSignatures';
import history from '../../../../../common/history';

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getAllSignatures() {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      delay(1000);
      const response = yield call(getAllSignaturesRequest, activeProfileId);
      yield put(signaturesActions.getAllSignaturesSuccess(response));
    } catch (e) {
      yield put(signaturesActions.getAllSignaturesFailure(e));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(signaturesActions.getAllSignatures(activeProfileId))
      : history.push('/authorization/profiles');
  }
}

export function* signaturesWatcher() {
  yield takeEvery(
    signaturesActions.getAllSignatures.toString(),
    getAllSignatures
  );
}
